import styled, { css } from 'styled-components';
import { FormattedDate } from '../../common/utils/formatters';

const courseEndDateStatusLabel = 'Course End Date' as const;

type TCourseEndDateProps = {
  courseEndDate: string;
};

const CourseEndDateWrapper = styled.div(
  ({ theme }) => css`
    padding-right: 20px;
    padding-left: 10px;
    text-align: center;
    @media (max-width: ${theme.breakpoints.max.md}) {
      padding-right: 15px;
    }
  `
);

const CourseEndDateText = styled.span(
  ({ theme }) => css`
    display: block;
    padding: 8px 0;
    color: ${theme.colors.main.font};
    font-size: ${theme.fonts.sizes.h6};
    font-weight: 500;
    text-align: center;
    background-color: ${theme.colors.lightWhiteSmoke};

    @media (max-width: ${theme.breakpoints.max.md}) {
      font-size: 0.75rem;
    }

    ${css`
      color: ${theme.colors.fundingStatuses.scheduled.text};
      background-color: ${theme.colors.fundingStatuses.scheduled.background};
    `}
  `
);

const CourseEndDate = ({ courseEndDate }: TCourseEndDateProps) => {
  return (
    <CourseEndDateWrapper>
      <CourseEndDateText>
        {courseEndDateStatusLabel}
        <br />
        {courseEndDate && <FormattedDate date={courseEndDate} />}
      </CourseEndDateText>
    </CourseEndDateWrapper>
  );
};

export { CourseEndDate, type TCourseEndDateProps };
